<template lang="pug">
  textarea.editable.textarea.component( 
    ref='input'
    :value='value'
    :disabled='disabled'
    @input='$emit( "update:value", $event.target.value )'
  )
</template>

<script>
  export default {
    name: 'editable.textarea.component',

    props: {
      value: String
    },

    data() {
      return {
        disabled: true
      }
    },

    methods: {
      edit() {
        console.log(this.$refs.input)
        if ( this.disabled ) {
          this.disabled = false
          this.$refs.input.focus()
        }
      }
    }
  }
</script>

<style lang="stylus" scoped>
  textarea
    padding inherit
    border-radius .25em
    width 100%
    box-sizing border-box
    border 1.5px solid rgba( 0 0 0 0 )
    resize none
    height 4em
    padding 8px 12px

  textarea:focus
    border-color rgb( 192 192 192 )
    background rgba( 255 255 255 .75 )
    resize vertical
</style>